import React, { CSSProperties } from "react"

type Props = {
  children: React.ReactNode
  style?: CSSProperties
}

const Article = ({ children, style }: Props) => {
  return (
    <div
      className={`pl-2 pr-2 max-w-md sm:pl-4 sm:max-w-xl md:pl-6 md:pr-28 md:max-w-3xl lg:pl-12 lg:pr-36 lg:max-w-4xl xl:pl-16 xl:pr-24 xl:max-w-5xl 2xl:pl-20 2xl:pr-12 2xl:max-w-6xl`}
      style={style}
    >
      <article className="pl-4 pr-16 sm:px-10 py-14">{children}</article>
    </div>
  )
}

export default Article
